var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNerdyBird(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 227,
    viewBox: "0 0 346 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M869.676 236.996C869.676 236.996 787.676 169.663 715.676 174.996C643.676 180.329 425.676 167.663 393.009 155.663C360.342 143.663 359.509 125.028 293.676 114.329C227.843 103.63 135.602 104.405 111.676 103.529C38.5086 100.862 0.341595 103.659 1.00859 98.3292C1.67559 92.9992 225.676 93.6622 293.676 98.3292C361.676 102.996 375.009 135.663 405.676 139.663C436.343 143.663 579.01 154.996 632.343 152.996C685.676 150.996 754.343 127.663 795.676 143.663C837.009 159.663 869.676 143.663 869.676 143.663",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.173 95.1621C187.339 97.2511 185.006 100.662 189.84 105.328",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195.173 95.1621C191.339 97.2511 189.006 100.662 193.84 105.328",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.767 91.1316C98.4826 90.6468 76.4194 89.6112 72.5029 89.3522C67.6355 89.0322 63.4178 79.3115 63.1448 68.4471C62.6364 48.0738 62.241 27.4745 72.55 18.2859C83.5981 8.43344 94.053 7.15305 112.732 7.3131C128.591 7.4449 145.118 9.17249 155.069 21.2373C163.335 31.2545 162.775 53.3224 161.598 65.5803C160.191 80.2295 157.343 90.5385 152.165 90.9292C146.987 91.3152 132.116 91.7153 113.767 91.1316Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.4122,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.156 7.50081C122.156 7.50081 125.578 5.14715 126.087 3.58432C126.595 2.02149 126.355 1 126.355 1",
    stroke: "black",
    strokeWidth: 1.4122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.389 7.23716C125.389 7.23716 126.523 5.81084 128.689 4.44572C129.809 3.73962 131.16 3.51367 131.16 3.51367",
    stroke: "black",
    strokeWidth: 1.4122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.383 29.6953L170.584 31.3099",
    stroke: "black",
    strokeWidth: 2.35366,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8418 24.9883L111.333 29.6956",
    stroke: "black",
    strokeWidth: 2.35366,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.866 31.2539L167.676 51.5048L123.479 49.3159",
    stroke: "black",
    strokeWidth: 1.4122,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.171 48.073L57.4863 45.3851L58.842 24.9883",
    stroke: "black",
    strokeWidth: 1.4122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5815 30.7368C89.2238 32.9681 85.9945 35.0911 82.2428 34.7522C78.4911 34.4132 75.7797 31.7536 76.0009 29.5035C76.3775 25.6529 79.5596 26.3731 83.3114 26.7168C87.0631 27.0604 90.1793 27.0086 89.5815 30.7368Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M152.089 33.8657C151.732 36.097 148.502 38.22 144.751 37.8811C140.999 37.5422 138.287 34.8825 138.509 32.6324C138.885 28.7818 142.067 29.5021 145.819 29.8457C149.566 30.1846 152.692 30.1375 152.089 33.8657Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M116.031 38.4037C114.238 38.0648 111.258 37.9424 108.848 38.6673C106.927 39.2416 105.76 40.3478 105.76 40.3478C108.622 51.0617 113.324 53.4577 113.324 53.4577C113.324 53.4577 121.383 48.0725 120.866 41.3834",
    stroke: "black",
    strokeWidth: 1.4122,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4902 90.293C82.4902 90.293 83.6859 93.428 86.2231 93.8752C88.7604 94.3224 95.2565 94.5107 97.6431 94.0259C99.606 93.6258 100.317 90.9238 100.317 90.9238",
    stroke: "black",
    strokeWidth: 1.4122,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M129.117 91.7282C129.117 91.7282 129.941 94.1854 132.478 94.6373C135.015 95.0845 141.512 95.1457 143.898 94.6609C145.861 94.2607 146.68 91.4316 146.68 91.4316",
    stroke: "black",
    strokeWidth: 1.4122,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8957 31.3968C30.8957 31.3968 16.1197 20.7058 11.1181 14.2332C9.3529 11.7619 9.4706 6.28957 12.4126 5.64252C20.9447 13.174 36.856 26.1877 40.5751 27.9139L40.9132 33.8807L30.8957 31.3968Z",
    stroke: "black",
    strokeWidth: 1.4122,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1888 29.2716C26.1888 29.2716 23.9431 29.2643 22.0976 33.3047C21.3931 34.7546 21.217 36.405 21.6 37.9709C21.6 37.9709 24.4427 37.1569 30.8936 37.9673C33.6956 38.2831 36.4687 38.8169 39.1875 39.5642C42.9403 40.0249 46.2246 35.2754 46.2246 35.2754C46.2246 35.2754 36.3013 32.7007 32.0079 31.7379C28.1242 30.8963 26.1888 29.2716 26.1888 29.2716Z",
    stroke: "black",
    strokeWidth: 1.4122,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1206 38.9272C21.8757 39.434 21.7599 39.9934 21.7836 40.5558C21.8072 41.1181 21.9695 41.6659 22.256 42.1503C23.8562 44.8536 25.8168 45.747 25.8168 45.747C31.5455 42.3622 37.8305 43.2368 37.8305 43.2368C37.8305 43.2368 42.0676 41.9168 41.1111 40.1588L39.202 39.5732C39.202 39.5732 26.1494 35.8619 22.1206 38.9272Z",
    stroke: "black",
    strokeWidth: 1.4122,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9515 22.3994C47.9337 22.1541 46.9431 21.8072 45.9946 21.3641C44.9819 20.8491 44.0163 20.2464 43.1088 19.563C39.8937 25.2985 37.5505 32.6643 36.2357 38.5091C36.944 38.6513 37.6744 38.6436 38.3795 38.4864C39.0847 38.3293 39.7491 38.0261 40.33 37.5966C46.4055 32.8934 49.9801 23.4893 48.9515 22.3994Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.4122,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.772 44.7129C32.8909 53.0684 48.4273 62.6659 63.373 69.9622",
    stroke: "black",
    strokeWidth: 1.4122
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5405 25.4121C50.8942 31.4139 64.8984 32.0024 64.8984 32.0024",
    stroke: "black",
    strokeWidth: 1.4122
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNerdyBird);
export default __webpack_public_path__ + "static/media/nerdy-bird.5343fd55b83a2624524a31482201ee99.svg";
export { ForwardRef as ReactComponent };